<template>
  <transition-group name="fade">
    <g class="munis" v-if="filteredMunis" key="munis">
      <g class="muni-lines" v-if="regionCoordinates">
        <line v-for="datum in filteredMunis" :key="datum.kommun_id"
          :x1="datum.x" :y1="datum.y" :x2="regionCoordinates.x" :y2="regionCoordinates.y" stroke="#555"
        />
       </g>
      <g
        v-for="(datum, index) in filteredMunis"
        :key="index"
        class="muni"
        :transform="`translate(${datum.x}, ${datum.y})`"
        :class="getClass(datum)"
      >
        <circle :r="datum.radius" :fill="getColor(datum.biggest_party)" @click="select($event, datum)" />
      </g>
    </g>
    <g class="hvas" v-if="data" :class="{ faded: filteredRegion }" key="hvas">
      <g
        v-for="datum in data"
        :key="datum.constituency_id"
        class="hva"
        :transform="`translate(${datum.x}, ${datum.y})`"
        :class="getClass(datum)"
      >
        <HeartIcon :color="getColor(datum.biggest_party)" @click="select($event, datum)" />
      </g>
    </g>
  </transition-group>
</template>

<script>
import { scaleSqrt } from 'd3-scale';

import parties from '../data/party_meta.json';

import HeartIcon from '../atoms/HeartIcon.vue';

export default {
  name: 'ScatterPlot',
  components: {
    HeartIcon,
  },
  emits: ['selected'],
  props: {
    width: Number,
    height: Number,
    selected: Object,
    filteredRegion: Number,
    xScale: Function,
    yScale: Function,
    margin: Object,
    showOutliers: Boolean,
  },
  data() {
    return {
      data: null,
      muniData: null,
      parties,
    }
  },
  computed: {
    viewBox() {
      return `0 0 ${this.width} ${this.height}`;
    },
    filteredMunis() {
      if (this.muniData && this.filteredRegion) {
        return this.muniData.filter(d => d.constituency_id === this.filteredRegion);
      }
      return null;
    },
    regionCoordinates() {
      if (this.data && this.filteredRegion) {
        const region = this.data.find(d => d.constituency_id === this.filteredRegion);
        return {
          x: this.xScale(region.leftright_num),
          y: this.yScale(region.conslib_num),
        }
      }
      return null;
    },
  },
  watch: {
  },
  created() {
    this.rScale = scaleSqrt()
      .domain([1, 100])
      .range([1, 10]);

    this.initGraph();
  },
  mounted() {
  },
  methods: {
    initGraph() {
      this.fetchData(`${process.env.BASE_URL}data/scatter.json`)
        .then((response) => {
          this.data = response;
        });

      this.fetchData(`${process.env.BASE_URL}data/muni_scatter.json`)
        .then((response) => {
          this.muniData = response;
        });
    },
    fetchData(path) {
      return new Promise((resolve) => {
        fetch(path)
          .then(response => response.json())
          .then((data) => {
            data.forEach((d) => {
              d['x'] = this.xScale(d.leftright_num);
              d['y'] = this.yScale(d.conslib_num);
              d['radius'] = this.rScale(d.cand_count);
            });

            resolve(data);
          });
      })
    },
    getColor(pid) {
      const party = this.parties[pid];
      return party ? party.color : '#333';
    },
    getClass(datum) {
      const classes = [];
      if (this.selected && this.selected === datum) {
        classes.push('selected');
      }
      if (this.filteredRegion && this.filteredRegion === datum.constituency_id) {
        classes.push('active');
      }
      return classes;
    },
    select(event, datum) {
      this.$emit('selected', {
        mouseX: event.pageX,
        mouseY: event.clientY,
        item: datum,
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.muni {
  fill-opacity: .5;
}

.muni-lines {
  stroke-opacity: .5;
}

.hvas {
  &.faded {
    .hva {
      fill-opacity: .05;

      &:not(.active) {
        pointer-events: none;

        circle {
          stroke: transparent;
        }
      }

      &.active {
        fill-opacity: .8;
      }
    }
  }

  .hva {
    fill-opacity: .5;
    transition: fill-opacity .5s;

    &.selected {
      stroke: #EFB42C;
      stroke-width: 1px;
      fill-opacity: .8;
    }

    circle {
      stroke: #fff;
      stroke-width: .5px;
    }
  }
}
</style>